// Function to trim carriage returns and empty spaces
export const trimString = (str) => {
  return str.replace(/[\r\n]+/g, '').trim()
}



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js